import React, { useState } from "react";
import styles from "./weather-description.module.css";
import { getWeatherEvents } from "../../../functions/getJourneyFunctions";
import FilterSelect from "../../filter-select/filter-select";
import EventDescription from "./event-description";
import { useSelector } from "react-redux";
import { selectJourneyEntities, selectWeatherJourneys } from "../../../store/selectors/journeySelectors";
import { LOCALES } from "../../../constants";

const option_KOR = "날씨 이벤트";
const option_ENG = "Weather Event";

export default function WeatherDescription({ lang, desc }) {
    const journeyEntities = useSelector((state) => selectJourneyEntities(state));
    const weatherJourneys = useSelector((state) => selectWeatherJourneys(state));

    const optionList = [
        { name: lang === LOCALES.KO ? option_KOR : option_ENG, value: "all" },
        ...weatherJourneys.map((id) => {
            const journey = journeyEntities[id];
            return { name: journey.name[lang], value: id };
        }),
    ];

    const [selected, setSeleted] = useState(optionList[0]);

    const tag =
        selected.value !== "all" ? (
            <EventDescription lang={lang} selected={journeyEntities[selected.value]} desc={desc} showEventName={false} />
        ) : (
            <></>
        );

    return (
        <div className={styles["weather-description"]}>
            <FilterSelect
                id={"weather"}
                list={optionList}
                selected={selected}
                isUseDispatch={false}
                changeFilter={setSeleted}
                forceWidth={"280px"}
            />
            {tag}
        </div>
    );
}
